import { http, HttpResponse } from 'msw'
import { StatusCodes } from 'http-status-codes'

import { allProducts } from 'app/mocks/data/catalogue/products'

import { api } from 'app/utils/constants'

export const deleteProduct = http.delete(
    `${process.env.REACT_APP_API_ADDRESS}/${api.catalogue.products.DETAILS}`,
    ({ params }) => {
        const { id } = params

        const productFound = allProducts.find(
            (product) => product.id.toString() === id,
        )

        // Not found
        if (!productFound) {
            return HttpResponse.json(undefined, {
                status: StatusCodes.NOT_FOUND,
            })
        }

        return HttpResponse.json(undefined, {
            status: StatusCodes.NO_CONTENT,
        })
    },
)
